import { ClbAvatar, ClbHeader, ClbHeaderNavigation, } from '@celebration/react'
import { Links as AvatarItem } from '@celebration/react/ClbAvatar/ClbAvatar.types'
import { FC, useMemo } from 'react'
import { isDeviceAn } from '../../../utils/styles'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { redirectLogout } from '../../auth'
import { RootState } from '../../../store/types'
import { Wrapper } from './styles/Header.styles'
import Notifications from './Notifications'
import SelectProfile from './SelectProfile'
const profileFlexibleRole = 'tpdigital_flexible_profile'

const Header: FC = (): React.ReactElement => {
  const navigate = useNavigate()
  const userInfo = useSelector((state: RootState) => state.auth.user)
  const avatarLabel = userInfo.info?.name ?? ''
  const avatarOptions: AvatarItem[] = useMemo(
    () => [
      {
        label: 'Sair',
        onClick: redirectLogout,
      },
    ],
    [],
  )
  const isProfileFlexibleUser = useMemo(() => {
    const roles = userInfo?.info?.roles || []
    return roles.some(role => role === profileFlexibleRole)
  }, [userInfo?.info?.roles])
  return (
    <Wrapper>
      <ClbHeader
        logo='/logo.svg'
        productName={isDeviceAn('mobile') ? 'TP Digital' : 'TP Digital Nexway'}
        onClickImage={() => navigate('/')}
      >
        <ClbHeaderNavigation>
          <></>
        </ClbHeaderNavigation>
        {isProfileFlexibleUser && (
          <SelectProfile />
        )}
        <Notifications />
        <ClbAvatar
          label={avatarLabel}
          size='md'
          showFullLabel={!isDeviceAn('tablet')}
          links={avatarOptions}
          dropdownPosition='left'
        ></ClbAvatar>
      </ClbHeader>
    </Wrapper>
  )
}
export default Header
